export type Language = "de" | "en" | "it" | "fr";

export type TranslationKey =
  | "nav.features"
  | "nav.howto"
  | "nav.pricing"
  | "nav.faq"
  | "nav.login"
  | "nav.signup"
  | "nav.signupFree"
  | "nav.signupPro"
  | "nav.shop"
  | "shop.url"
  | "shop.title"
  | "shop.subtitle"
  | "hero.badge"
  | "hero.trust.users"
  | "mockup.users"
  | "mockup.usersSub"
  | "hero.title.before"
  | "hero.title.accent"
  | "hero.title.after"
  | "hero.subtitle"
  | "hero.cta.start"
  | "hero.cta.demo"
  | "mockup.url"
  | "mockup.title"
  | "mockup.necessary"
  | "mockup.preferences"
  | "mockup.statistics"
  | "mockup.marketing"
  | "mockup.acceptAll"
  | "mockup.savePref"
  | "stats.features"
  | "stats.featuresLabel"
  | "stats.languages"
  | "stats.languagesLabel"
  | "stats.compliance"
  | "stats.complianceLabel"
  | "stats.line"
  | "stats.lineLabel"
  | "trust.gdpr"
  | "trust.eprivacy"
  | "trust.ttdsg"
  | "trust.languages"
  | "trust.hash"
  | "pillars.title"
  | "pillars.subtitle"
  | "pillars.eyebrow"
  | "pillars.obtain.title"
  | "pillars.obtain.desc"
  | "pillars.manage.title"
  | "pillars.manage.desc"
  | "pillars.optimize.title"
  | "pillars.optimize.desc"
  | "pillars.preview.bannerTitle"
  | "pillars.preview.bannerDomain"
  | "pillars.preview.bannerText"
  | "pillars.preview.necessary"
  | "pillars.preview.preferences"
  | "pillars.preview.statistics"
  | "pillars.preview.marketing"
  | "pillars.preview.save"
  | "pillars.preview.acceptAll"
  | "pillars.preview.optInLabel"
  | "pillars.dash.title"
  | "pillars.dash.range"
  | "pillars.dash.optInRate"
  | "pillars.dash.scanTitle"
  | "pillars.dash.scanSub"
  | "how.eyebrow"
  | "integrations.group.analytics"
  | "integrations.group.marketing"
  | "integrations.group.cms"
  | "features.title"
  | "features.subtitle"
  | "features.f1.title"
  | "features.f1.desc"
  | "features.f2.title"
  | "features.f2.desc"
  | "features.f3.title"
  | "features.f3.desc"
  | "features.f4.title"
  | "features.f4.desc"
  | "features.f5.title"
  | "features.f5.desc"
  | "features.f6.title"
  | "features.f6.desc"
  | "features.f7.title"
  | "features.f7.desc"
  | "features.f8.title"
  | "features.f8.desc"
  | "how.title"
  | "how.subtitle"
  | "how.s1.title"
  | "how.s1.desc"
  | "how.s2.title"
  | "how.s2.desc"
  | "how.s3.title"
  | "how.s3.desc"
  | "how.s4.title"
  | "how.s4.desc"
  | "comparison.title"
  | "comparison.subtitle"
  | "comparison.recommended"
  | "comparison.col1"
  | "comparison.col2"
  | "comparison.col3"
  | "pricing.title"
  | "pricing.subtitle"
  | "pricing.popular"
  | "pricing.free.title"
  | "pricing.free.price"
  | "pricing.free.tagline"
  | "pricing.pro.title"
  | "pricing.pro.price"
  | "pricing.pro.tagline"
  | "pricing.business.title"
  | "pricing.business.price"
  | "pricing.business.tagline"
  | "pricing.cta"
  | "pricing.ctaContact"
  | "faq.title"
  | "faq.subtitle"
  | "cta.title"
  | "cta.subtitle"
  | "cta.button"
  | "footer.tagline"
  | "footer.product"
  | "footer.legal"
  | "footer.languages"
  | "footer.imprint"
  | "footer.privacy"
  | "footer.terms"
  | "footer.rights"
  | "integrations.title"
  | "integrations.subtitle"
  | "integrations.cms"
  | "integrations.shop"
  | "integrations.analytics"
  | "integrations.marketing"
  | "integrations.systems"
  | "integrations.systemsDesc"
  | "integrations.eyebrow"
  | "integrations.point1"
  | "integrations.point2"
  | "integrations.point3"
  | "integrations.andMore"
  | "snippet.title"
  | "snippet.subtitle"
  | "snippet.copy"
  | "snippet.copied"
  | "snippet.note"
  | "usecases.title"
  | "usecases.subtitle"
  | "usecases.shop.title"
  | "usecases.shop.desc"
  | "usecases.agency.title"
  | "usecases.agency.desc"
  | "usecases.corporate.title"
  | "usecases.corporate.desc"
  | "usecases.blog.title"
  | "usecases.blog.desc"
  | "usecases.saas.title"
  | "usecases.saas.desc"
  | "usecases.ngo.title"
  | "usecases.ngo.desc"
  | "testimonials.title"
  | "testimonials.subtitle"
  | "testimonials.t1.quote"
  | "testimonials.t1.name"
  | "testimonials.t1.role"
  | "testimonials.t2.quote"
  | "testimonials.t2.name"
  | "testimonials.t2.role"
  | "testimonials.t3.quote"
  | "testimonials.t3.name"
  | "testimonials.t3.role";

export const translations: Record<Language, Record<TranslationKey, string>> = {
  de: {
    "nav.features": "Funktionen",
    "nav.howto": "So funktioniert's",
    "nav.pricing": "Preise",
    "nav.faq": "FAQ",
    "nav.login": "Anmelden",
    "nav.signup": "Jetzt starten",
    "nav.signupFree": "Kostenlos starten",
    "nav.signupPro": "Pro kaufen",
    "nav.shop": "Shop",
    "shop.url": "https://shopv3-dev.worldsoft.ch/de/index/collection/26",
    "shop.title": "CookieRobot Shop",
    "shop.subtitle": "Wählen Sie Ihren Pro-Plan und starten Sie sofort durch.",
    "hero.badge": "DSGVO, ePrivacy & TTDSG-konform",
    "hero.trust.users": "Bereits über 7.000 Websites vertrauen auf CookieRobot",
    "mockup.users": "7.000+ Websites",
    "mockup.usersSub": "vertrauen auf CookieRobot",
    "hero.title.before": "Ihr Cookie-Banner – automatisch ",
    "hero.title.accent": "rechtssicher",
    "hero.title.after": " und DSGVO-konform",
    "hero.subtitle": "CookieRobot ist die DSGVO-konforme Consent-Management-Lösung für Ihre Website. Eine Zeile Code reicht — und Ihre Besucher bekommen ein vollständig anpassbares Cookie-Banner mit automatischem Script-Blocking, Cookie-Scanner und rechtssicherem Hash-Logging.",
    "hero.cta.start": "Jetzt kostenlos starten",
    "hero.cta.demo": "So funktioniert's",
    "mockup.url": "https://ihre-website.de",
    "mockup.title": "Cookie-Einstellungen",
    "mockup.necessary": "Notwendig",
    "mockup.preferences": "Präferenzen",
    "mockup.statistics": "Statistik",
    "mockup.marketing": "Marketing",
    "mockup.acceptAll": "Alle akzeptieren",
    "mockup.savePref": "Auswahl speichern",
    "stats.features": "7.000+",
    "stats.featuresLabel": "Websites vertrauen CookieRobot",
    "stats.languages": "2 Millionen",
    "stats.languagesLabel": "Cookie-Abfragen pro Tag",
    "stats.compliance": "DSGVO",
    "stats.complianceLabel": "konform",
    "stats.line": "",
    "stats.lineLabel": "",
    "trust.gdpr": "DSGVO-konform",
    "trust.eprivacy": "ePrivacy",
    "trust.ttdsg": "TTDSG",
    "trust.languages": "4 Sprachen",
    "trust.hash": "Hash-Logging",
    "pillars.title": "Drei Säulen für rechtssichere Cookies",
    "pillars.subtitle": "Einwilligung einholen, Cookies verwalten, Opt-in-Raten verbessern — alles in einem Tool. CookieRobot vereint Banner, Scanner, Skript-Blocker und Einwilligungsnachweis in einer einzigen Plattform, die Sie ohne Programmierkenntnisse vollständig steuern.",
    "pillars.obtain.title": "Einwilligungen einholen",
    "pillars.obtain.desc": "Rechtskonforme Einwilligungen nach DSGVO- und TTDSG-Standards einholen.",
    "pillars.manage.title": "Cookies verwalten",
    "pillars.manage.desc": "Alle Cookies, Skripte und Einwilligungen zentral an einem Ort verwalten.",
    "pillars.optimize.title": "Opt-in-Raten verbessern",
    "pillars.optimize.desc": "Mit echten Daten Ihre Zustimmungsraten kontinuierlich optimieren.",
    "pillars.eyebrow": "Plattform",
    "pillars.preview.bannerTitle": "Cookie-Einstellungen",
    "pillars.preview.bannerDomain": "ihre-website.de",
    "pillars.preview.bannerText": "Wir verwenden Cookies, um Ihnen die bestmögliche Nutzung unserer Website zu ermöglichen.",
    "pillars.preview.necessary": "Notwendig",
    "pillars.preview.preferences": "Präferenzen",
    "pillars.preview.statistics": "Statistik",
    "pillars.preview.marketing": "Marketing",
    "pillars.preview.save": "Auswahl speichern",
    "pillars.preview.acceptAll": "Alle akzeptieren",
    "pillars.preview.optInLabel": "Opt-in-Rate",
    "pillars.dash.title": "Consent-Dashboard",
    "pillars.dash.range": "Letzte 7 Tage",
    "pillars.dash.optInRate": "Durchschnittliche Opt-in-Rate",
    "pillars.dash.scanTitle": "Cookie-Scan",
    "pillars.dash.scanSub": "24 neue erkannt",
    "how.eyebrow": "Setup",
    "integrations.group.analytics": "Analyse & Tag-Manager",
    "integrations.group.marketing": "Marketing & Werbung",
    "integrations.group.cms": "CMS & Shop-Systeme",
    "features.title": "Alles, was Sie für rechtssicheres Consent-Management brauchen",
    "features.subtitle": "Jede Funktion wurde entwickelt, um Ihre Website schneller, sicherer und konformer zu machen — von der automatischen Cookie-Erkennung über das zuverlässige Script-Blocking bis hin zum rechtssicheren Einwilligungsnachweis.",
    "features.f1.title": "Automatischer Cookie-Scanner",
    "features.f1.desc": "Findet und kategorisiert alle Cookies auf Ihrer Website vollautomatisch.",
    "features.f2.title": "Auto-Script-Blocking",
    "features.f2.desc": "Blockiert Skripte (Analytics, Pixel) zuverlässig bis zur Einwilligung.",
    "features.f3.title": "1-Zeilen-Integration",
    "features.f3.desc": "Nur ein einziges Skript-Tag im Header erforderlich.",
    "features.f4.title": "4 Sprachen",
    "features.f4.desc": "Banner verfügbar in DE, EN, IT, FR — automatische Browser-Erkennung.",
    "features.f5.title": "Vollständig anpassbar",
    "features.f5.desc": "Farben, Logo und Design perfekt an Ihre Marke anpassbar.",
    "features.f6.title": "Multi-Domain-Verwaltung",
    "features.f6.desc": "Alle Ihre Websites und Kunden übersichtlich in einem Dashboard.",
    "features.f7.title": "Cookie- & Tracker-Datenbank",
    "features.f7.desc": "Greifen Sie auf unsere vorgefertigte Datenbank mit tausenden Cookies zu.",
    "features.f8.title": "Hash-basiertes Logging",
    "features.f8.desc": "Rechtssicherer Nachweis jeder einzelnen Einwilligung per Hash.",
    "how.title": "In vier Schritten startklar",
    "how.subtitle": "Von Null auf rechtssicher in unter fünf Minuten — ohne Entwickler.",
    "how.s1.title": "Skript einbinden",
    "how.s1.desc": "Eine Zeile Code in den Header Ihrer Website einfügen — fertig.",
    "how.s2.title": "Scan läuft",
    "how.s2.desc": "CookieRobot scannt Ihre Website und kategorisiert alle Cookies.",
    "how.s3.title": "Banner aktiv",
    "how.s3.desc": "Das Banner erscheint und sammelt rechtssichere Einwilligungen.",
    "how.s4.title": "Protokolliert",
    "how.s4.desc": "Jede Einwilligung wird hash-basiert revisionssicher gespeichert.",
    "comparison.title": "CookieRobot im Vergleich",
    "comparison.subtitle": "Mehr Funktionen, fairer Preis, weniger Komplexität.",
    "comparison.recommended": "Empfohlen",
    "comparison.col1": "Einstiegspreis",
    "comparison.col2": "Subseiten-Limit",
    "comparison.col3": "Sprachen",
    "pricing.title": "Faire Preise für jede Website",
    "pricing.subtitle": "Keine versteckten Kosten. Jederzeit kündbar.",
    "pricing.popular": "Beliebteste",
    "pricing.free.title": "Free",
    "pricing.free.price": "CHF 0",
    "pricing.free.tagline": "Für kleine private Websites.",
    "pricing.pro.title": "Pro",
    "pricing.pro.price": "CHF 4.90",
    "pricing.pro.tagline": "Für Unternehmen und Agenturen.",
    "pricing.business.title": "Business",
    "pricing.business.price": "CHF 14.90",
    "pricing.business.tagline": "Für große Setups & Multi-Domain.",
    "pricing.cta": "Kostenlos starten",
    "pricing.ctaContact": "Kontakt aufnehmen",
    "faq.title": "Häufig gestellte Fragen",
    "faq.subtitle": "Alles, was Sie wissen müssen, bevor Sie loslegen.",
    "cta.title": "Bereit für rechtssichere Cookies?",
    "cta.subtitle": "Starten Sie heute und machen Sie Ihre Website in unter fünf Minuten DSGVO-konform.",
    "cta.button": "Jetzt kostenlos starten",
    "footer.tagline": "DSGVO-konformes Cookie-Banner für Ihre Website. Scannen, kategorisieren, dokumentieren — alles automatisch und revisionssicher.",
    "footer.product": "Produkt",
    "footer.legal": "Rechtliches",
    "footer.languages": "Sprachen",
    "footer.imprint": "Impressum",
    "footer.privacy": "Datenschutz",
    "footer.terms": "AGB",
    "footer.rights": "Alle Rechte vorbehalten.",
    "integrations.title": "Funktioniert mit Ihren Tools",
    "integrations.subtitle": "CookieRobot funktioniert mit jeder Website und blockiert die wichtigsten Shop-, Analyse- und Marketing-Tools – out of the box, ohne manuelles Coding.",
    "integrations.cms": "Content & Websites",
    "integrations.shop": "Online-Shops",
    "integrations.analytics": "Analyse & Tag-Manager",
    "integrations.marketing": "Marketing & Werbung",
    "integrations.systems": "Websites & Online-Shops",
    "integrations.systemsDesc": "Funktioniert mit allen Systemen. Egal welche Plattform Sie nutzen – CookieRobot lässt sich überall einbinden, ohne Anpassung am Code.",
    "integrations.eyebrow": "Integrationen",
    "integrations.point1": "Automatisches Blockieren von Analyse-, Werbe- und Marketing-Skripten bis zur Einwilligung.",
    "integrations.point2": "Funktioniert mit jeder Website, jedem CMS und jedem Online-Shop – ohne Plug-in.",
    "integrations.point3": "Out of the box konfiguriert für die populärsten Tracking- und Marketing-Tools.",
    "integrations.andMore": "… und viele weitere Tools werden automatisch erkannt.",
    "snippet.title": "Eine Zeile Code – fertig.",
    "snippet.subtitle": "Fügen Sie das Skript einmal in den <head> Ihrer Website ein. CookieRobot übernimmt ab sofort Banner, Blocking, Scanner und Logging – vollautomatisch.",
    "snippet.copy": "Kopieren",
    "snippet.copied": "Kopiert",
    "snippet.note": "Funktioniert mit jedem CMS, Baukasten oder eigenem HTML.",
    "usecases.title": "Für jede Website. Für jede Branche.",
    "usecases.subtitle": "Vom Online-Shop bis zur Behörde – CookieRobot passt sich an Ihre Anforderungen an und sorgt überall für rechtssichere Einwilligungen.",
    "usecases.shop.title": "Online-Shops",
    "usecases.shop.desc": "Conversion-freundliche Banner für Shopify, WooCommerce, Magento & Co. Mit Google Consent Mode v2 für höhere Reichweite.",
    "usecases.agency.title": "Agenturen",
    "usecases.agency.desc": "Verwalten Sie unbegrenzt viele Kunden-Domains in einem Dashboard. Eigenes Branding, zentrale Updates, ein Vertrag.",
    "usecases.corporate.title": "Unternehmen",
    "usecases.corporate.desc": "Mehrsprachige Banner, eigene Cookie-Kategorien und revisionssicheres Hash-Logging – auch für internationale Konzernseiten.",
    "usecases.blog.title": "Blogs & Publisher",
    "usecases.blog.desc": "Schnelles Laden, kein Layout-Shift, voller Adsense-Support und Consent-String für IAB TCF v2.2.",
    "usecases.saas.title": "SaaS & Startups",
    "usecases.saas.desc": "Schlanke Integration ohne Performance-Einbußen. Per API steuerbar, mit Webhook-Logging und Audit-Export.",
    "usecases.ngo.title": "Vereine & Behörden",
    "usecases.ngo.desc": "Barrierefreies Banner, klare Sprache, vollständige DSGVO-Dokumentation für Aufsichtsbehörden.",
    "testimonials.title": "Was unsere Kundinnen und Kunden sagen",
    "testimonials.subtitle": "Über 7.000 Websites verlassen sich täglich auf CookieRobot – vom Einzelunternehmer bis zur Konzern-IT.",
    "testimonials.t1.quote": "Endlich ein Cookie-Banner, das wir nicht ständig nachpflegen müssen. Setup in fünf Minuten – seitdem läuft es einfach.",
    "testimonials.t1.name": "Sandra Berger",
    "testimonials.t1.role": "Geschäftsführerin, Berger & Partner GmbH",
    "testimonials.t2.quote": "Wir verwalten 80+ Kundenseiten. Mit CookieRobot haben wir alle DSGVO-Themen an einem Ort – das spart uns jede Woche Stunden.",
    "testimonials.t2.name": "Marc Hoffmann",
    "testimonials.t2.role": "Lead Developer, Pixelwerk Agentur",
    "testimonials.t3.quote": "Die Anwaltsprüfung haben wir auf Anhieb bestanden. Das Hash-Logging hat alle Anforderungen unseres Datenschutzbeauftragten erfüllt.",
    "testimonials.t3.name": "Dr. Julia Weiss",
    "testimonials.t3.role": "Head of Legal, Nordwind Retail AG",
  },
  en: {
    "nav.features": "Features",
    "nav.howto": "How it works",
    "nav.pricing": "Pricing",
    "nav.faq": "FAQ",
    "nav.login": "Log in",
    "nav.signup": "Get started",
    "nav.signupFree": "Start for free",
    "nav.signupPro": "Buy Pro",
    "nav.shop": "Shop",
    "shop.url": "https://shopv3-dev.worldsoft.ch/en/index/collection/26",
    "shop.title": "CookieRobot Shop",
    "shop.subtitle": "Choose your Pro plan and get started right away.",
    "hero.badge": "GDPR, ePrivacy & TTDSG compliant",
    "hero.trust.users": "Trusted by over 7,000 websites",
    "mockup.users": "7,000+ websites",
    "mockup.usersSub": "trust CookieRobot",
    "hero.title.before": "Your cookie banner – automatically ",
    "hero.title.accent": "compliant",
    "hero.title.after": " and GDPR-ready",
    "hero.subtitle": "CookieRobot is the GDPR-compliant consent management solution for your website. One line of code is enough — and your visitors get a fully customizable cookie banner with automatic script blocking, cookie scanning, and legally-sound hash logging.",
    "hero.cta.start": "Start for free",
    "hero.cta.demo": "How it works",
    "mockup.url": "https://your-website.com",
    "mockup.title": "Cookie settings",
    "mockup.necessary": "Necessary",
    "mockup.preferences": "Preferences",
    "mockup.statistics": "Statistics",
    "mockup.marketing": "Marketing",
    "mockup.acceptAll": "Accept all",
    "mockup.savePref": "Save selection",
    "stats.features": "7,000+",
    "stats.featuresLabel": "websites trust CookieRobot",
    "stats.languages": "2 Million",
    "stats.languagesLabel": "cookie consents per day",
    "stats.compliance": "GDPR",
    "stats.complianceLabel": "compliant",
    "stats.line": "",
    "stats.lineLabel": "",
    "trust.gdpr": "GDPR-compliant",
    "trust.eprivacy": "ePrivacy",
    "trust.ttdsg": "TTDSG",
    "trust.languages": "4 Languages",
    "trust.hash": "Hash-Logging",
    "pillars.title": "Three pillars of compliant cookies",
    "pillars.subtitle": "Obtain consent, manage cookies, optimize opt-in rates — all in one tool. CookieRobot combines banner, scanner, script blocker and consent proof in a single platform that you can fully control without any coding skills.",
    "pillars.obtain.title": "Obtain consents",
    "pillars.obtain.desc": "Collect legally compliant consents that meet GDPR and TTDSG standards.",
    "pillars.manage.title": "Manage cookies",
    "pillars.manage.desc": "Manage all cookies, scripts and consents from one central dashboard.",
    "pillars.optimize.title": "Optimize opt-ins",
    "pillars.optimize.desc": "Use real-world data to continuously improve your visitor consent rates.",
    "pillars.eyebrow": "Platform",
    "pillars.preview.bannerTitle": "Cookie settings",
    "pillars.preview.bannerDomain": "your-website.com",
    "pillars.preview.bannerText": "We use cookies to give you the best possible experience on our website.",
    "pillars.preview.necessary": "Necessary",
    "pillars.preview.preferences": "Preferences",
    "pillars.preview.statistics": "Statistics",
    "pillars.preview.marketing": "Marketing",
    "pillars.preview.save": "Save selection",
    "pillars.preview.acceptAll": "Accept all",
    "pillars.preview.optInLabel": "Opt-in rate",
    "pillars.dash.title": "Consent dashboard",
    "pillars.dash.range": "Last 7 days",
    "pillars.dash.optInRate": "Average opt-in rate",
    "pillars.dash.scanTitle": "Cookie scan",
    "pillars.dash.scanSub": "24 new detected",
    "how.eyebrow": "Setup",
    "integrations.group.analytics": "Analytics & tag managers",
    "integrations.group.marketing": "Marketing & advertising",
    "integrations.group.cms": "CMS & shop systems",
    "features.title": "Everything you need for secure consent management",
    "features.subtitle": "Every feature is built to make your website faster, safer, and more compliant — from automatic cookie detection and reliable script blocking to legally sound consent logging.",
    "features.f1.title": "Auto cookie scanner",
    "features.f1.desc": "Automatically finds and categorizes all cookies on your site.",
    "features.f2.title": "Auto script blocking",
    "features.f2.desc": "Reliably blocks scripts (Analytics, Pixel) until consent is given.",
    "features.f3.title": "1-line integration",
    "features.f3.desc": "Requires only a single script tag in your header.",
    "features.f4.title": "4 languages",
    "features.f4.desc": "Banner available in DE, EN, IT, FR — automatic browser detection.",
    "features.f5.title": "Fully customizable",
    "features.f5.desc": "Adapt colors, logo, and design to perfectly match your brand.",
    "features.f6.title": "Multi-domain",
    "features.f6.desc": "Manage all your sites and clients clearly in one dashboard.",
    "features.f7.title": "Cookie database",
    "features.f7.desc": "Access our pre-built database of thousands of known cookies.",
    "features.f8.title": "Hash-based logging",
    "features.f8.desc": "Legally secure proof of every single consent via hash.",
    "how.title": "Ready in four steps",
    "how.subtitle": "From zero to compliant in under five minutes — no developer required.",
    "how.s1.title": "Add script",
    "how.s1.desc": "Paste one line of code into your website's header — done.",
    "how.s2.title": "Scan runs",
    "how.s2.desc": "CookieRobot scans your website and categorizes all cookies.",
    "how.s3.title": "Banner active",
    "how.s3.desc": "The banner appears and collects legally compliant consents.",
    "how.s4.title": "Logged",
    "how.s4.desc": "Every consent is securely hash-logged and audit-proof stored.",
    "comparison.title": "CookieRobot vs others",
    "comparison.subtitle": "More features, fairer price, less complexity.",
    "comparison.recommended": "Recommended",
    "comparison.col1": "Starting price",
    "comparison.col2": "Subpage limit",
    "comparison.col3": "Languages",
    "pricing.title": "Fair pricing for every website",
    "pricing.subtitle": "No hidden fees. Cancel anytime.",
    "pricing.popular": "Most popular",
    "pricing.free.title": "Free",
    "pricing.free.price": "CHF 0",
    "pricing.free.tagline": "For small personal websites.",
    "pricing.pro.title": "Pro",
    "pricing.pro.price": "CHF 4.90",
    "pricing.pro.tagline": "For businesses and agencies.",
    "pricing.business.title": "Business",
    "pricing.business.price": "CHF 14.90",
    "pricing.business.tagline": "For large setups & multi-domain.",
    "pricing.cta": "Start for free",
    "pricing.ctaContact": "Contact us",
    "faq.title": "Frequently asked questions",
    "faq.subtitle": "Everything you need to know before getting started.",
    "cta.title": "Ready for compliant cookies?",
    "cta.subtitle": "Start today and make your website GDPR-compliant in under five minutes.",
    "cta.button": "Start for free",
    "footer.tagline": "GDPR-compliant cookie banner for your website. Scan, categorise and document — fully automated and audit-proof.",
    "footer.product": "Product",
    "footer.legal": "Legal",
    "footer.languages": "Languages",
    "footer.imprint": "Imprint",
    "footer.privacy": "Privacy Policy",
    "footer.terms": "Terms of Service",
    "footer.rights": "All rights reserved.",
    "integrations.title": "Works with your stack",
    "integrations.subtitle": "CookieRobot works with every website and blocks the most popular shop, analytics and marketing tools — out of the box, no manual coding required.",
    "integrations.cms": "Content & websites",
    "integrations.shop": "Online shops",
    "integrations.analytics": "Analytics & tag managers",
    "integrations.marketing": "Marketing & advertising",
    "integrations.systems": "Websites & online shops",
    "integrations.systemsDesc": "Works with every system. Whatever platform you use, CookieRobot can be integrated without touching your code.",
    "integrations.eyebrow": "Integrations",
    "integrations.point1": "Automatically blocks analytics, advertising and marketing scripts until consent is given.",
    "integrations.point2": "Works with every website, every CMS and every online shop — no plugin required.",
    "integrations.point3": "Pre-configured out of the box for the most popular tracking and marketing tools.",
    "integrations.andMore": "… and many more tools are detected automatically.",
    "snippet.title": "One line of code — done.",
    "snippet.subtitle": "Drop the script once into the <head> of your site. From that moment, CookieRobot handles banner, blocking, scanner and logging — fully automated.",
    "snippet.copy": "Copy",
    "snippet.copied": "Copied",
    "snippet.note": "Works with any CMS, site builder or hand-coded HTML.",
    "usecases.title": "Built for every website. For every industry.",
    "usecases.subtitle": "From online shop to public authority — CookieRobot adapts to your needs and delivers legally compliant consent everywhere.",
    "usecases.shop.title": "Online shops",
    "usecases.shop.desc": "Conversion-friendly banners for Shopify, WooCommerce, Magento and more. With Google Consent Mode v2 for higher reach.",
    "usecases.agency.title": "Agencies",
    "usecases.agency.desc": "Manage unlimited client domains from one dashboard. Custom branding, central updates, a single contract.",
    "usecases.corporate.title": "Enterprise",
    "usecases.corporate.desc": "Multilingual banners, custom cookie categories and audit-proof hash logging — also for international corporate sites.",
    "usecases.blog.title": "Blogs & publishers",
    "usecases.blog.desc": "Fast loading, no layout shift, full AdSense support and a consent string for IAB TCF v2.2.",
    "usecases.saas.title": "SaaS & startups",
    "usecases.saas.desc": "Lightweight integration with zero performance hit. Controllable via API, with webhook logging and audit export.",
    "usecases.ngo.title": "Nonprofits & public sector",
    "usecases.ngo.desc": "Accessible banner, clear language, full GDPR documentation for supervisory authorities.",
    "testimonials.title": "What our customers say",
    "testimonials.subtitle": "Over 7,000 websites rely on CookieRobot every day — from solopreneurs to enterprise IT teams.",
    "testimonials.t1.quote": "Finally a cookie banner we don't have to keep babysitting. Five-minute setup — and it has just worked ever since.",
    "testimonials.t1.name": "Sandra Berger",
    "testimonials.t1.role": "Managing Director, Berger & Partner GmbH",
    "testimonials.t2.quote": "We manage 80+ client websites. With CookieRobot all the GDPR work lives in one place — that saves us hours every week.",
    "testimonials.t2.name": "Marc Hoffmann",
    "testimonials.t2.role": "Lead Developer, Pixelwerk Agency",
    "testimonials.t3.quote": "We passed our legal review on the first try. The hash logging satisfied every requirement from our data protection officer.",
    "testimonials.t3.name": "Dr. Julia Weiss",
    "testimonials.t3.role": "Head of Legal, Nordwind Retail AG",
  },
  it: {
    "nav.features": "Funzionalità",
    "nav.howto": "Come funziona",
    "nav.pricing": "Prezzi",
    "nav.faq": "FAQ",
    "nav.login": "Accedi",
    "nav.signup": "Inizia ora",
    "nav.signupFree": "Inizia gratis",
    "nav.signupPro": "Acquista Pro",
    "nav.shop": "Shop",
    "shop.url": "https://shopv3-dev.worldsoft.ch/en/index/collection/26",
    "shop.title": "CookieRobot Shop",
    "shop.subtitle": "Scegli il tuo piano Pro e inizia subito.",
    "hero.badge": "Conforme a GDPR, ePrivacy e TTDSG",
    "hero.trust.users": "Oltre 7.000 siti web si affidano a CookieRobot",
    "mockup.users": "7.000+ siti web",
    "mockup.usersSub": "si affidano a CookieRobot",
    "hero.title.before": "Il tuo banner cookie – automaticamente ",
    "hero.title.accent": "a norma",
    "hero.title.after": " e conforme al GDPR",
    "hero.subtitle": "CookieRobot è la soluzione di gestione del consenso conforme al GDPR per il tuo sito web. Basta una riga di codice — e i tuoi visitatori ottengono un banner cookie completamente personalizzabile con blocco automatico degli script, scanner di cookie e logging hash legalmente sicuro.",
    "hero.cta.start": "Inizia gratis",
    "hero.cta.demo": "Come funziona",
    "mockup.url": "https://il-tuo-sito.it",
    "mockup.title": "Impostazioni cookie",
    "mockup.necessary": "Necessari",
    "mockup.preferences": "Preferenze",
    "mockup.statistics": "Statistiche",
    "mockup.marketing": "Marketing",
    "mockup.acceptAll": "Accetta tutti",
    "mockup.savePref": "Salva selezione",
    "stats.features": "7.000+",
    "stats.featuresLabel": "siti si affidano a CookieRobot",
    "stats.languages": "2 Milioni",
    "stats.languagesLabel": "richieste cookie al giorno",
    "stats.compliance": "GDPR",
    "stats.complianceLabel": "conforme",
    "stats.line": "",
    "stats.lineLabel": "",
    "trust.gdpr": "Conforme al GDPR",
    "trust.eprivacy": "ePrivacy",
    "trust.ttdsg": "TTDSG",
    "trust.languages": "4 Lingue",
    "trust.hash": "Hash-Logging",
    "pillars.title": "Tre pilastri per cookie conformi",
    "pillars.subtitle": "Ottenere consensi, gestire cookie, ottimizzare gli opt-in — tutto in un solo strumento. CookieRobot riunisce banner, scanner, blocco script e prova del consenso in un'unica piattaforma, completamente gestibile senza competenze tecniche.",
    "pillars.obtain.title": "Ottieni consensi",
    "pillars.obtain.desc": "Raccogli consensi conformi alle normative GDPR e TTDSG vigenti.",
    "pillars.manage.title": "Gestisci i cookie",
    "pillars.manage.desc": "Gestisci tutti i cookie, script e consensi da un'unica dashboard.",
    "pillars.optimize.title": "Ottimizza gli opt-in",
    "pillars.optimize.desc": "Usa dati reali per migliorare continuamente i tassi di consenso.",
    "pillars.eyebrow": "Piattaforma",
    "pillars.preview.bannerTitle": "Impostazioni cookie",
    "pillars.preview.bannerDomain": "tuo-sito.it",
    "pillars.preview.bannerText": "Utilizziamo i cookie per offrirti la migliore esperienza possibile sul nostro sito.",
    "pillars.preview.necessary": "Necessari",
    "pillars.preview.preferences": "Preferenze",
    "pillars.preview.statistics": "Statistiche",
    "pillars.preview.marketing": "Marketing",
    "pillars.preview.save": "Salva selezione",
    "pillars.preview.acceptAll": "Accetta tutto",
    "pillars.preview.optInLabel": "Tasso di opt-in",
    "pillars.dash.title": "Dashboard consensi",
    "pillars.dash.range": "Ultimi 7 giorni",
    "pillars.dash.optInRate": "Tasso medio di opt-in",
    "pillars.dash.scanTitle": "Scansione cookie",
    "pillars.dash.scanSub": "24 nuovi rilevati",
    "how.eyebrow": "Setup",
    "integrations.group.analytics": "Analisi & tag manager",
    "integrations.group.marketing": "Marketing & pubblicità",
    "integrations.group.cms": "CMS & e-commerce",
    "features.title": "Tutto ciò che ti serve per la gestione del consenso",
    "features.subtitle": "Ogni funzione è pensata per rendere il tuo sito più veloce, sicuro e conforme — dal rilevamento automatico dei cookie al blocco affidabile degli script, fino alla prova legalmente solida del consenso.",
    "features.f1.title": "Scanner automatico",
    "features.f1.desc": "Trova e categorizza automaticamente tutti i cookie sul tuo sito.",
    "features.f2.title": "Blocco script",
    "features.f2.desc": "Blocca script (Analytics, Pixel) in modo affidabile senza consenso.",
    "features.f3.title": "Integrazione in 1 riga",
    "features.f3.desc": "Richiede solo un singolo tag script nell'intestazione.",
    "features.f4.title": "4 lingue",
    "features.f4.desc": "Banner disponibile in DE, EN, IT, FR — rilevamento automatico del browser.",
    "features.f5.title": "Completamente personalizzabile",
    "features.f5.desc": "Adatta colori, logo e design al tuo brand.",
    "features.f6.title": "Multi-dominio",
    "features.f6.desc": "Gestisci tutti i tuoi siti e clienti in una sola dashboard.",
    "features.f7.title": "Database cookie",
    "features.f7.desc": "Accedi al nostro database con migliaia di cookie noti.",
    "features.f8.title": "Logging hash",
    "features.f8.desc": "Prova legalmente sicura per ogni consenso tramite hash.",
    "how.title": "Pronto in quattro passaggi",
    "how.subtitle": "Da zero a conforme in meno di cinque minuti — senza sviluppatore.",
    "how.s1.title": "Inserisci script",
    "how.s1.desc": "Incolla una riga di codice nell'header del tuo sito — pronto.",
    "how.s2.title": "Scansione",
    "how.s2.desc": "CookieRobot scansiona il tuo sito e categorizza tutti i cookie.",
    "how.s3.title": "Banner attivo",
    "how.s3.desc": "Il banner appare e raccoglie consensi legalmente conformi.",
    "how.s4.title": "Registrato",
    "how.s4.desc": "Ogni consenso viene registrato con hash e archiviato in modo sicuro.",
    "comparison.title": "CookieRobot a confronto",
    "comparison.subtitle": "Più funzioni, prezzo equo, meno complessità.",
    "comparison.recommended": "Consigliato",
    "comparison.col1": "Prezzo di partenza",
    "comparison.col2": "Limite sottopagine",
    "comparison.col3": "Lingue",
    "pricing.title": "Prezzi giusti per ogni sito web",
    "pricing.subtitle": "Nessun costo nascosto. Cancellabile in qualsiasi momento.",
    "pricing.popular": "Più popolare",
    "pricing.free.title": "Free",
    "pricing.free.price": "CHF 0",
    "pricing.free.tagline": "Per piccoli siti personali.",
    "pricing.pro.title": "Pro",
    "pricing.pro.price": "CHF 4.90",
    "pricing.pro.tagline": "Per aziende e agenzie.",
    "pricing.business.title": "Business",
    "pricing.business.price": "CHF 14.90",
    "pricing.business.tagline": "Per grandi setup & multi-dominio.",
    "pricing.cta": "Inizia gratis",
    "pricing.ctaContact": "Contattaci",
    "faq.title": "Domande frequenti",
    "faq.subtitle": "Tutto quello che devi sapere prima di iniziare.",
    "cta.title": "Pronto per cookie conformi?",
    "cta.subtitle": "Inizia oggi e rendi il tuo sito conforme al GDPR in meno di cinque minuti.",
    "cta.button": "Inizia gratis",
    "footer.tagline": "Banner cookie conforme al GDPR per il tuo sito. Scansione, categorizzazione e documentazione — tutto automatico e verificabile.",
    "footer.product": "Prodotto",
    "footer.legal": "Legale",
    "footer.languages": "Lingue",
    "footer.imprint": "Note legali",
    "footer.privacy": "Privacy",
    "footer.terms": "Termini",
    "footer.rights": "Tutti i diritti riservati.",
    "integrations.title": "Funziona con i tuoi strumenti",
    "integrations.subtitle": "CookieRobot funziona con qualsiasi sito e blocca i principali strumenti e-commerce, di analisi e marketing — pronto all'uso, senza coding manuale.",
    "integrations.cms": "Contenuti & siti",
    "integrations.shop": "E-commerce",
    "integrations.analytics": "Analisi & tag manager",
    "integrations.marketing": "Marketing & pubblicità",
    "integrations.systems": "Siti & e-commerce",
    "integrations.systemsDesc": "Funziona con qualsiasi sistema. Qualunque piattaforma utilizzi, CookieRobot si integra ovunque senza modificare il codice.",
    "integrations.eyebrow": "Integrazioni",
    "integrations.point1": "Blocca automaticamente script di analisi, pubblicità e marketing fino al consenso.",
    "integrations.point2": "Funziona con qualsiasi sito web, CMS e shop online — senza plugin.",
    "integrations.point3": "Preconfigurato per i più popolari strumenti di tracciamento e marketing.",
    "integrations.andMore": "… e molti altri strumenti vengono riconosciuti automaticamente.",
    "snippet.title": "Una riga di codice — fatto.",
    "snippet.subtitle": "Inserisci lo script una sola volta nel <head> del tuo sito. Da quel momento CookieRobot gestisce banner, blocco, scanner e logging — in modo totalmente automatico.",
    "snippet.copy": "Copia",
    "snippet.copied": "Copiato",
    "snippet.note": "Funziona con qualsiasi CMS, builder o HTML personalizzato.",
    "usecases.title": "Per ogni sito. Per ogni settore.",
    "usecases.subtitle": "Dall'e-commerce all'ente pubblico — CookieRobot si adatta alle tue esigenze e garantisce un consenso legalmente conforme ovunque.",
    "usecases.shop.title": "E-commerce",
    "usecases.shop.desc": "Banner orientati alla conversione per Shopify, WooCommerce, Magento e altri. Con Google Consent Mode v2 per maggiore copertura.",
    "usecases.agency.title": "Agenzie",
    "usecases.agency.desc": "Gestisci domini clienti illimitati da un'unica dashboard. Branding personalizzato, aggiornamenti centralizzati, un solo contratto.",
    "usecases.corporate.title": "Aziende",
    "usecases.corporate.desc": "Banner multilingue, categorie cookie personalizzate e hash logging a prova di audit — anche per siti corporate internazionali.",
    "usecases.blog.title": "Blog & editori",
    "usecases.blog.desc": "Caricamento veloce, nessun layout shift, supporto completo AdSense e consent string per IAB TCF v2.2.",
    "usecases.saas.title": "SaaS & startup",
    "usecases.saas.desc": "Integrazione leggera senza impatti sulle prestazioni. Controllabile via API, con webhook logging ed export di audit.",
    "usecases.ngo.title": "Associazioni & PA",
    "usecases.ngo.desc": "Banner accessibile, linguaggio chiaro, documentazione GDPR completa per le autorità di vigilanza.",
    "testimonials.title": "Cosa dicono i nostri clienti",
    "testimonials.subtitle": "Oltre 7.000 siti web si affidano a CookieRobot ogni giorno — dai liberi professionisti ai team IT aziendali.",
    "testimonials.t1.quote": "Finalmente un banner cookie che non dobbiamo continuamente seguire. Setup in cinque minuti — e da allora funziona e basta.",
    "testimonials.t1.name": "Sandra Berger",
    "testimonials.t1.role": "Amministratrice, Berger & Partner GmbH",
    "testimonials.t2.quote": "Gestiamo oltre 80 siti clienti. Con CookieRobot tutta la parte GDPR è in un unico posto — risparmiamo ore ogni settimana.",
    "testimonials.t2.name": "Marc Hoffmann",
    "testimonials.t2.role": "Lead Developer, Pixelwerk Agency",
    "testimonials.t3.quote": "Abbiamo superato la verifica legale al primo tentativo. L'hash logging ha soddisfatto tutti i requisiti del nostro DPO.",
    "testimonials.t3.name": "Dr. Julia Weiss",
    "testimonials.t3.role": "Head of Legal, Nordwind Retail AG",
  },
  fr: {
    "nav.features": "Fonctionnalités",
    "nav.howto": "Comment ça marche",
    "nav.pricing": "Tarifs",
    "nav.faq": "FAQ",
    "nav.login": "Connexion",
    "nav.signup": "Démarrer",
    "nav.signupFree": "Démarrer gratuitement",
    "nav.signupPro": "Acheter Pro",
    "nav.shop": "Shop",
    "shop.url": "https://shopv3-dev.worldsoft.ch/fr/index/collection/26",
    "shop.title": "Boutique CookieRobot",
    "shop.subtitle": "Choisissez votre plan Pro et lancez-vous immédiatement.",
    "hero.badge": "Conforme RGPD, ePrivacy & TTDSG",
    "hero.trust.users": "Plus de 7 000 sites web font confiance à CookieRobot",
    "mockup.users": "7 000+ sites web",
    "mockup.usersSub": "font confiance à CookieRobot",
    "hero.title.before": "Votre bannière cookies – automatiquement ",
    "hero.title.accent": "conforme",
    "hero.title.after": " au RGPD",
    "hero.subtitle": "CookieRobot est la solution de gestion du consentement conforme au RGPD pour votre site web. Une seule ligne de code suffit — et vos visiteurs reçoivent une bannière cookies entièrement personnalisable avec blocage automatique des scripts, scanner de cookies et journalisation hash légalement sûre.",
    "hero.cta.start": "Démarrer gratuitement",
    "hero.cta.demo": "Comment ça marche",
    "mockup.url": "https://votre-site.fr",
    "mockup.title": "Paramètres cookies",
    "mockup.necessary": "Nécessaires",
    "mockup.preferences": "Préférences",
    "mockup.statistics": "Statistiques",
    "mockup.marketing": "Marketing",
    "mockup.acceptAll": "Tout accepter",
    "mockup.savePref": "Enregistrer",
    "stats.features": "7 000+",
    "stats.featuresLabel": "sites font confiance à CookieRobot",
    "stats.languages": "2 Millions",
    "stats.languagesLabel": "de consentements par jour",
    "stats.compliance": "RGPD",
    "stats.complianceLabel": "conforme",
    "stats.line": "",
    "stats.lineLabel": "",
    "trust.gdpr": "Conforme RGPD",
    "trust.eprivacy": "ePrivacy",
    "trust.ttdsg": "TTDSG",
    "trust.languages": "4 Langues",
    "trust.hash": "Hash-Logging",
    "pillars.title": "Trois piliers pour des cookies conformes",
    "pillars.subtitle": "Obtenir le consentement, gérer les cookies, optimiser les opt-ins — le tout en un seul outil. CookieRobot réunit bannière, scanner, bloqueur de scripts et preuve de consentement dans une plateforme unique que vous pilotez entièrement sans aucune compétence technique.",
    "pillars.obtain.title": "Obtenir les consentements",
    "pillars.obtain.desc": "Collectez des consentements conformes aux normes RGPD et TTDSG.",
    "pillars.manage.title": "Gérer les cookies",
    "pillars.manage.desc": "Gérez tous les cookies, scripts et consentements depuis un tableau de bord.",
    "pillars.optimize.title": "Optimiser les opt-ins",
    "pillars.optimize.desc": "Utilisez des données réelles pour améliorer vos taux de consentement.",
    "pillars.eyebrow": "Plateforme",
    "pillars.preview.bannerTitle": "Paramètres des cookies",
    "pillars.preview.bannerDomain": "votre-site.fr",
    "pillars.preview.bannerText": "Nous utilisons des cookies pour vous offrir la meilleure expérience possible sur notre site.",
    "pillars.preview.necessary": "Nécessaires",
    "pillars.preview.preferences": "Préférences",
    "pillars.preview.statistics": "Statistiques",
    "pillars.preview.marketing": "Marketing",
    "pillars.preview.save": "Enregistrer la sélection",
    "pillars.preview.acceptAll": "Tout accepter",
    "pillars.preview.optInLabel": "Taux d'opt-in",
    "pillars.dash.title": "Tableau de bord consentements",
    "pillars.dash.range": "7 derniers jours",
    "pillars.dash.optInRate": "Taux d'opt-in moyen",
    "pillars.dash.scanTitle": "Scan des cookies",
    "pillars.dash.scanSub": "24 nouveaux détectés",
    "how.eyebrow": "Installation",
    "integrations.group.analytics": "Analyse & tag managers",
    "integrations.group.marketing": "Marketing & publicité",
    "integrations.group.cms": "CMS & e-commerce",
    "features.title": "Tout ce dont vous avez besoin pour la gestion du consentement",
    "features.subtitle": "Chaque fonctionnalité est conçue pour rendre votre site plus rapide, sécurisé et conforme — de la détection automatique des cookies au blocage fiable des scripts, jusqu'à une preuve juridiquement solide du consentement.",
    "features.f1.title": "Scanner automatique",
    "features.f1.desc": "Trouve et catégorise tous les cookies sur votre site.",
    "features.f2.title": "Blocage de scripts",
    "features.f2.desc": "Bloque les scripts (Analytics, Pixel) sans consentement.",
    "features.f3.title": "Intégration en 1 ligne",
    "features.f3.desc": "Une seule balise script dans votre en-tête.",
    "features.f4.title": "4 langues",
    "features.f4.desc": "Bannière disponible en DE, EN, IT, FR — détection automatique.",
    "features.f5.title": "Entièrement personnalisable",
    "features.f5.desc": "Adaptez les couleurs, le logo et le design à votre marque.",
    "features.f6.title": "Multi-domaine",
    "features.f6.desc": "Gérez tous vos sites et clients dans un seul tableau de bord.",
    "features.f7.title": "Base de données",
    "features.f7.desc": "Accédez à notre base de données avec des milliers de cookies.",
    "features.f8.title": "Journalisation hash",
    "features.f8.desc": "Preuve légalement sécurisée pour chaque consentement via hash.",
    "how.title": "Prêt en quatre étapes",
    "how.subtitle": "De zéro à conforme en moins de cinq minutes — sans développeur.",
    "how.s1.title": "Ajouter le script",
    "how.s1.desc": "Collez une ligne de code dans l'en-tête de votre site — terminé.",
    "how.s2.title": "Analyse",
    "how.s2.desc": "CookieRobot scanne votre site et catégorise tous les cookies.",
    "how.s3.title": "Bannière active",
    "how.s3.desc": "La bannière apparaît et recueille des consentements conformes.",
    "how.s4.title": "Enregistré",
    "how.s4.desc": "Chaque consentement est enregistré avec un hash sécurisé.",
    "comparison.title": "CookieRobot face à la concurrence",
    "comparison.subtitle": "Plus de fonctionnalités, prix juste, moins de complexité.",
    "comparison.recommended": "Recommandé",
    "comparison.col1": "Prix de départ",
    "comparison.col2": "Limite sous-pages",
    "comparison.col3": "Langues",
    "pricing.title": "Des prix justes pour chaque site",
    "pricing.subtitle": "Aucun frais caché. Annulable à tout moment.",
    "pricing.popular": "Le plus populaire",
    "pricing.free.title": "Gratuit",
    "pricing.free.price": "CHF 0",
    "pricing.free.tagline": "Pour les petits sites personnels.",
    "pricing.pro.title": "Pro",
    "pricing.pro.price": "CHF 4.90",
    "pricing.pro.tagline": "Pour entreprises et agences.",
    "pricing.business.title": "Business",
    "pricing.business.price": "CHF 14.90",
    "pricing.business.tagline": "Pour grandes installations & multi-domaine.",
    "pricing.cta": "Démarrer gratuitement",
    "pricing.ctaContact": "Nous contacter",
    "faq.title": "Questions fréquentes",
    "faq.subtitle": "Tout ce que vous devez savoir avant de commencer.",
    "cta.title": "Prêt pour des cookies conformes ?",
    "cta.subtitle": "Commencez aujourd'hui et rendez votre site conforme au RGPD en moins de cinq minutes.",
    "cta.button": "Démarrer gratuitement",
    "footer.tagline": "Bandeau cookies conforme au RGPD pour votre site. Analyse, catégorisation et documentation — tout est automatique et infalsifiable.",
    "footer.product": "Produit",
    "footer.legal": "Légal",
    "footer.languages": "Langues",
    "footer.imprint": "Mentions légales",
    "footer.privacy": "Confidentialité",
    "footer.terms": "Conditions",
    "footer.rights": "Tous droits réservés.",
    "integrations.title": "Compatible avec vos outils",
    "integrations.subtitle": "CookieRobot fonctionne avec n'importe quel site et bloque les principaux outils e-commerce, d'analyse et marketing — prêt à l'emploi, sans code à écrire.",
    "integrations.cms": "Contenus & sites",
    "integrations.shop": "E-commerce",
    "integrations.analytics": "Analyse & tag manager",
    "integrations.marketing": "Marketing & publicité",
    "integrations.systems": "Sites & e-commerce",
    "integrations.systemsDesc": "Compatible avec tous les systèmes. Quelle que soit votre plateforme, CookieRobot s'intègre partout sans modifier votre code.",
    "integrations.eyebrow": "Intégrations",
    "integrations.point1": "Bloque automatiquement les scripts d'analyse, publicité et marketing jusqu'au consentement.",
    "integrations.point2": "Fonctionne avec tout site web, tout CMS et toute boutique en ligne — sans plugin.",
    "integrations.point3": "Préconfiguré pour les outils de tracking et marketing les plus populaires.",
    "integrations.andMore": "… et bien d'autres outils sont détectés automatiquement.",
    "snippet.title": "Une ligne de code — c'est tout.",
    "snippet.subtitle": "Ajoutez le script une seule fois dans le <head> de votre site. À partir de là, CookieRobot gère bannière, blocage, scanner et journalisation — entièrement automatisé.",
    "snippet.copy": "Copier",
    "snippet.copied": "Copié",
    "snippet.note": "Fonctionne avec n'importe quel CMS, constructeur ou HTML manuel.",
    "usecases.title": "Pour chaque site. Pour chaque secteur.",
    "usecases.subtitle": "De la boutique en ligne à l'administration publique — CookieRobot s'adapte à vos besoins et garantit un consentement conforme partout.",
    "usecases.shop.title": "E-commerce",
    "usecases.shop.desc": "Bannières orientées conversion pour Shopify, WooCommerce, Magento, etc. Avec Google Consent Mode v2 pour plus de portée.",
    "usecases.agency.title": "Agences",
    "usecases.agency.desc": "Gérez un nombre illimité de domaines clients dans un seul tableau de bord. Branding personnalisé, mises à jour centralisées, un seul contrat.",
    "usecases.corporate.title": "Entreprises",
    "usecases.corporate.desc": "Bannières multilingues, catégories de cookies personnalisées et journalisation hash à l'épreuve d'un audit — aussi pour les sites de groupes internationaux.",
    "usecases.blog.title": "Blogs & éditeurs",
    "usecases.blog.desc": "Chargement rapide, aucun saut de mise en page, support AdSense complet et consent string pour IAB TCF v2.2.",
    "usecases.saas.title": "SaaS & startups",
    "usecases.saas.desc": "Intégration légère sans impact sur la performance. Pilotable via API, avec journalisation par webhook et export d'audit.",
    "usecases.ngo.title": "Associations & secteur public",
    "usecases.ngo.desc": "Bannière accessible, langage clair, documentation RGPD complète pour les autorités de contrôle.",
    "testimonials.title": "Ce que disent nos clients",
    "testimonials.subtitle": "Plus de 7 000 sites web font confiance à CookieRobot chaque jour — du solo entrepreneur aux équipes IT d'entreprise.",
    "testimonials.t1.quote": "Enfin une bannière cookies qu'on n'a plus besoin de surveiller. Cinq minutes d'installation — et depuis, ça marche tout seul.",
    "testimonials.t1.name": "Sandra Berger",
    "testimonials.t1.role": "Directrice générale, Berger & Partner GmbH",
    "testimonials.t2.quote": "Nous gérons plus de 80 sites clients. Avec CookieRobot, tout le RGPD est centralisé — cela nous fait gagner des heures chaque semaine.",
    "testimonials.t2.name": "Marc Hoffmann",
    "testimonials.t2.role": "Lead Developer, Pixelwerk Agency",
    "testimonials.t3.quote": "Nous avons passé l'audit juridique du premier coup. La journalisation par hash a satisfait toutes les exigences de notre DPO.",
    "testimonials.t3.name": "Dr. Julia Weiss",
    "testimonials.t3.role": "Head of Legal, Nordwind Retail AG",
  },
};
